import { Fragment } from 'react';

// Phone regex requires either a leading `+` or a `(` so we don't turn
// bare digit runs (order ids, message ids, timestamps, ZIP+suffix
// concatenations) into `tel:` links.
const LINK_REGEX =
  /(https?:\/\/[^\s<]+|www\.[^\s<]+\.[^\s<]{2,}|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}|(?:\+\d[\d\s()-]{7,}\d|\(\d{3}\)\s*\d{3}[\s-]?\d{4}))/gi;

function getHref(match: string): string {
  if (match.includes('@') && !match.startsWith('http')) {
    return `mailto:${match}`;
  }
  if (/^[\d+\s()-]+$/.test(match)) {
    return `tel:${match.replace(/[\s()-]/g, '')}`;
  }
  if (match.startsWith('www.')) return `https://${match}`;
  return match;
}

export function LinkifiedText({ text }: { text: string | null | undefined }) {
  if (!text) return null;
  const parts = text.split(LINK_REGEX);
  return (
    <span>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <a
            key={i}
            href={getHref(part)}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'inherit', textDecoration: 'underline' }}
          >
            {part}
          </a>
        ) : (
          <Fragment key={i}>{part}</Fragment>
        ),
      )}
    </span>
  );
}
